<template>
  <v-container fluid>
    <v-row align="center" justify="center">
      <v-col xs="12" sm="8" md="6" lg="4">
        <v-card flat>
          <v-card-title>
            <!-- <v-img
              alt="Sharylist Logo"
              contain
              class="mr-2"
              src="@/assets/logo.png"
              transition="scale-transition"
              max-width="35"
            />-->
            Login
          </v-card-title>
          <v-card-text>
            <sl-alert v-show="loginFailed" type="error">
              <!-- <v-alert
              v-if="loginFailed"
              border="left"
              colored-border
              color="error"
              class="error--text"
              dense
              tile
              >-->
              Invalid email or password.
            </sl-alert>
            <!-- <div class="error--text">
              Invalid email or password.
            </div>-->
            <v-form ref="form" v-model="formIsValid">
              <v-text-field
                :rules="emailRules"
                v-model="email"
                id="email"
                label="Email"
                name="email"
                type="email"
                required
                solo
                autofocus
                @input="loginFailed = false"
              />
              <v-text-field
                :type="passwordShow ? 'text' : 'password'"
                :rules="passwordRules"
                v-model="password"
                id="password"
                label="Password"
                name="password"
                required
                solo
                hint="At least 8 characters"
                counter
                @input="loginFailed = false"
                @keyup.enter="userLogin"
              >
                <v-icon slot="append" @click="passwordShow = !passwordShow">{{
                  passwordShow ? 'mdi-eye-off-outline' : 'mdi-eye-outline'
                }}</v-icon>
              </v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-container>
              <v-btn :disabled="!formIsValid" outlined block color="secondary" @click="userLogin">
                Log in
              </v-btn>
              <!-- <v-spacer></v-spacer>
            <v-btn
              :disabled="!formIsValid"
              icon
              large
              color="primary"
              @click="userLogin"
            >
              <v-icon>mdi-login</v-icon>
            </v-btn>-->
            </v-container>
          </v-card-actions>
          <v-card-text>
            Forgot you pasword?
            <a href="https://sharylist.freshdesk.com/" @click.stop>Ask us for help</a>.
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapMutations } from 'vuex'

import Logger from '@/lib/Logger'

import User from '@/models/User'
import Session from '@/models/Session'

import SlAlert from '@/components/SlAlert'

export default {
  components: {
    SlAlert,
  },

  data() {
    return {
      email: '',
      emailRules: [v => !!v || 'Required', v => /.+@.+\..+/.test(v) || 'E-mail must be valid'],
      formIsValid: false,
      password: '',
      passwordRules: [v => !!v || 'Required', v => (v && v.length >= 8) || 'Min 8 characters'],
      passwordShow: false,
      loginFailed: false,
    }
  },

  computed: {
    //
  },

  mounted() {
    this.errorsDataAccessAllSetFalse()
    this.nodeCurrentSet({})
  },

  methods: {
    async userLogin() {
      if (this.formIsValid) {
        // Logger.debug("userLogin")
        try {
          let userLogged = await User.doLogin(this.email, this.password)
          this.$gtag.set({ user_id: userLogged.id })
          Logger.debug('gtag config user_id:', userLogged.id)
          this.$gtag.event('login', {
            event_label: this.email,
          })
          this.userLoggedIn(userLogged) // FIXME: da mettere in User
          const workspaceId = Session.getWorkspaceId()
          if (workspaceId) {
            this.$router.push({ name: 'Dashboard', params: { workspaceId } })
          } else {
            this.$router.push({ name: 'Settings' })
          }
        } catch (e) {
          if (e.name == 'INVALID_USER_PASSWORD') {
            this.loginFailed = true
            // this.$gtag.event('login', { method: 'Google' })
            this.$gtag.exception({
              description: 'login INVALID_USER_PASSWORD for user: ' + this.email,
              fatal: false,
            })
            // this.$refs.form.reset();
          } else {
            Logger.error(e)
            this.toastSet({
              message: 'Error in user login',
              color: 'error',
            })
            this.$gtag.exception({
              description: 'login unknown falure for user: ' + this.email + e,
              fatal: false,
            })
          }
        }
      } else {
        this.toastSet({
          message: 'Error in form fields validation',
          color: 'error',
        })
      }
    },
    ...mapMutations(['nodeCurrentSet', 'userLoggedIn', 'toastSet', 'errorsDataAccessAllSetFalse']),
  },
}
</script>
